import * as Yup from "yup";
import { FormGroup } from "../../components/form";

export const InviteUserForm = (rest: any, label: string, advisory: string, domain?: string, emailValidationMsg?: string): FormGroup => ({
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "my-3 text-purple font-bold",
      },
      label: label,
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "mb-0",
      },
      label: advisory,
    },
    {
      type: "field",
      key: "userEmail",
      fieldType: "input",
      props: {
        className: "mb-0",
      },
      label: "Email",
      validation: Yup.string()
        .required("A response is required")
        .when("bypass", {
          is: true,
          then: (schema) =>
            schema.matches(new RegExp(`^[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9.-]+[.][a-zA-Z]{2,}$`), { message: "Please enter a valid email address" }),
          otherwise: (schema) =>
            schema.matches(new RegExp(`^[a-zA-Z0-9._%+'-]+@${domain?.replace(/\./g, "\\.") ?? "[a-zA-Z0-9.-]+[.][a-zA-Z]{2,}"}$`), {
              message: emailValidationMsg ?? "Please enter a valid email address",
            }),
        }),
    },
    {
      type: "field",
      key: "bypass",
      fieldType: "checkbox",
      label: "email domain bypass - QA",
      hideExpression: (context) => context.isProd || domain == null,
    },
    {
      type: "component",
      body: () => <></>,
      defaultValue: {
        inviteRedirectUrl: import.meta.env.VITE_POSTLOGOUTREDIRECTURI,
        ...rest,
      },
    },
  ],
});
